const table = 'logs';
export const API_ENDPOINT = process.env.REACT_APP_API_URL;

export const ReadByCampaignId = async (campaignId) => {
    const response = await fetch(`${API_ENDPOINT}/${table}?filters[campaign]=${campaignId}&populate=user`);

    return await response.json();
};
